import script from "./PayinsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PayinsTable.vue?vue&type=script&setup=true&lang=js"

import "./PayinsTable.vue?vue&type=style&index=0&id=5e407505&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e407505"]])

export default __exports__